import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";
import { Button, LoadingOverlay } from "@covertree/ui";

import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useCancelTllCoverageMutation } from "@redux/coverages/coveragesApi";
import { useAppSelector } from "@redux/hooks/useAppSelector";
import { selectAddedCoverageDetails } from "@redux/coverages/coveragesSlice";
import { PROOF_OF_COVERAGE_ROUTES } from "@routing/Residents/ProofOfCoverage";
import { moveBackInPathname } from "@utils";

export default function ActiveTLLFound() {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { updatedResident: resident, alreadyAddedCoverageId } = useAppSelector(
    selectAddedCoverageDetails
  );

  const goForward = () => {
    navigate({
      pathname: `${moveBackInPathname(location.pathname, 1)}/${PROOF_OF_COVERAGE_ROUTES.COVERAGE_ADDED}`,
      search: createSearchParams(searchParams).toString(),
    });
  };

  const [cancelTllCoverage, { isSuccess, isLoading, isError }] =
    useCancelTllCoverageMutation();

  const handleCancel = () => {
    cancelTllCoverage({
      coverageId: alreadyAddedCoverageId,
      residentId: resident.id,
    });
  };

  if (isLoading) return <LoadingOverlay />;

  if (isError)
    return (
      <Typography>
        Could not cancel Brl Coverage. Please check your internet connection or
        contact our team.
      </Typography>
    );

  if (isSuccess) {
    goForward();
    return <LoadingOverlay />;
  }

  return (
    <Grid
      container
      display="flex"
      direction="column"
      gap={4}
      alignItems="flex-start"
      justifyContent="space-around">
      <img
        src="/images/icons/checkmark.webp"
        alt="success"
        width={80}
        height={80}
      />
      <Grid item xs={12}>
        <Typography fontSize={theme.spacing(4)}>
          Non mandatory active BRL policy found
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={theme.spacing(2.5)}>
          Another active BRL policy was found for this resident, which is not
          mandatory. Do you want to cancel the resident from the BRL program?
        </Typography>
      </Grid>
      <Grid item container gap={2}>
        <Button onClick={handleCancel}>Cancel Resident From BRL</Button>
        <Button onClick={goForward} variant="outlined">
          Keep Resident in BRL
        </Button>
      </Grid>
    </Grid>
  );
}
